<script>
    import { fly } from 'svelte/transition';
    
    // Tooltips
    import Tooltip from './Tooltip.svelte';
    let showingTooltip = false;
    const showTooltip = () => { showingTooltip = true; }
    const hideTooltip = () => { showingTooltip = false; }

    import IconTourCategories from './icons/tourCategories.svg';
    import IconRequestInfo from './icons/info.svg';
    import IconWebsite from './icons/website.svg';

    export let requestInfoUrl;
    export let websiteUrl;

    let active = false;

    function toggleActive(){
        return active ? active = false : active = true;
    }

</script>

<style>
:root {
    --hamburger-menu-bg-color: var(--theme-color);
    --hamburger-menu-bg-color-rgb: var(--theme-color-rgb);
}

.ham {
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 400ms;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.hamRotate.active {
  transform: rotate(45deg);
}

.line {
  fill:none;
  transition: stroke-dasharray 400ms, stroke-dashoffset 400ms;
  stroke:#fff;
  stroke-width:5.5;
  stroke-linecap:round;
}

.ham4 .top {
  stroke-dasharray: 40 121;
}
.ham4 .bottom {
  stroke-dasharray: 40 121;
}
.ham4.active .top {
  stroke-dashoffset: -68px;
}
.ham4.active .bottom {
  stroke-dashoffset: -68px;
}

.hamburger-menu-container {
    position: absolute;
    z-index: 900;
    top: 20px;
    right: 20px;
}
.hamburger-icon {
    background: rgba(var(--hamburger-menu-bg-color-rgb),0.8);
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 5px;
    border: 3px transparent solid;
    width: 40px;
    height: 40px;
}

.hamburger-icon:hover {
    background: rgba(var(--hamburger-menu-bg-color-rgb),1);
    border: 3px solid rgba(255,255,255,1);
}

.hamburger-menu {
    background: #fff;
    text-align: center;
    padding: 1rem 2rem;
    position: relative;
    top: 50px;
    border-radius: 0.5rem;
    border-top-right-radius: 0;
    box-shadow: 0 10px 15px rgba(0,0,0,0.25);
}



.hamburger-menu ul {
    list-style: none;
    width: 100%;
    padding: 0;
    margin: 0;
    text-align: left;
}

.hamburger-menu li{
    border-left: 3px solid transparent;
}


.hamburger-menu li a{
    width: 100%;
    padding: 0.5rem;
    text-decoration: none;
    color: #000;
    text-align: left;
    font-family: 'Raleway', sans-serif;
    font-weight: 500;
    display: flex;
    justify-content: left;
    align-items: center;
}

.hamburger-menu li a:hover{
    background: var(--hamburger-menu-bg-color);
    color: #fff;
    border-radius: 5px;
}

.hamburger-menu li span {
    padding-left: 0.5rem;
}

.logo {
    margin-top: 1rem;
}

.logo:hover img{
}

:global(.hamburger-menu li svg) {
    fill:#000; 
    width: 1.5em; 
    height: 1.5em;
}

:global(.hamburger-menu li:hover svg) {
    fill:#fff; 
}

</style>

<div class="hamburger-menu-container" transition:fly={{y: -300, duration: 500 }} on:mouseenter={showTooltip} on:mouseleave={hideTooltip}>
    <div class="hamburger-icon">
        <Tooltip text={active ? "Close Menu" : "Open Menu"} showingTooltip={showingTooltip} position={'left'} />
        <svg class="ham hamRotate ham4 {active ? 'active' : ''}" viewBox="0 0 100 100" width="40" height="40" on:click={toggleActive}>
            <path class="line top" d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20" />
            <path class="line middle" d="m 70,50 h -40" />
            <path class="line bottom" d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20" />
        </svg>
    </div>
    {#if active}
    <div class="hamburger-menu" transition:fly={{x: 300, duration: 400 }}>
        <ul>
            {#if websiteUrl}
            <li><a href="{websiteUrl}" target="_blank"><IconWebsite/><span>Website</span></a></li>
            {/if}

            {#if requestInfoUrl}
            <li><a href="{requestInfoUrl}" target="_blank"><IconRequestInfo/><span>Request Info</span></a></li>
            {/if}
        </ul>
        
        <div class="logo">
            <a href="https://covecreekproductions.com/">
                <img src="./images/poweredby_cc.png" width="120" alt="Powered by CoveCreek Productions">
            </a>
        </div>
    </div>
    {/if}
</div>